
export const pageTitleMap : { [key: string]: any } = {
    login: '登录'
    ,member: '成员页面'
    ,timer: '学习计时'
}
